import { useEffect, useRef, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";

export default function MusicPlayer({ started, opened }) {
    const audioRef = useRef(null);
    const [playing, setPlaying] = useState(false);

    useEffect(() => {
        if (!started) return;
        const audio = audioRef.current;
        if (!audio) return;
        audio.volume = 0.5;
        audio
            .play()
            .then(() => setPlaying(true))
            .catch(() => {
                const resume = () => {
                    audio.play().then(() => setPlaying(true)).catch(() => {});
                    window.removeEventListener("pointerdown", resume);
                };
                window.addEventListener("pointerdown", resume);
            });
    }, [started]);

    const toggle = () => {
        const audio = audioRef.current;
        if (!audio) return;
        if (playing) {
            audio.pause();
            setPlaying(false);
        } else {
            audio.play().then(() => setPlaying(true)).catch(() => {});
        }
    };

    return (
        <>
            <audio ref={audioRef} src="/music/chaudhary.mp3" loop preload="auto" />
            {opened && (
                <button
                    data-testid="music-toggle-button"
                    onClick={toggle}
                    aria-label={playing ? "Mute music" : "Play music"}
                    className="absolute right-4 top-4 z-50 flex h-11 w-11 items-center justify-center rounded-full transition-transform duration-300 hover:scale-110"
                    style={{
                        background: "rgba(255,253,250,0.9)",
                        border: "1px solid rgba(212,175,55,0.5)",
                        color: "var(--wine)",
                        boxShadow: "0 10px 25px -12px rgba(138,59,78,0.4)",
                    }}
                >
                    {playing ? <Volume2 size={17} /> : <VolumeX size={17} />}
                </button>
            )}
        </>
    );
}
